export const legalCompanyDetails = {
  brandName: "Realvore",
  serviceName: "Realvore",
  legalEntityName: "ShiftC Ltd",
  registeredAddress: "66 Paul Street, London, EC2A 4NA, United Kingdom",
  companyRegistrationNumber: "17266307",
  vatNumber: null as string | null,
  // Domain convention: @realvore.com for brand-facing/general contact,
  // @shiftc.co.uk for formal legal entity correspondence (privacy/legal notices).
  contactEmail: "hello@realvore.com",
  privacyEmail: "privacy@shiftc.co.uk",
  legalEmail: "legal@shiftc.co.uk",
  governingLaw: "England and Wales",
  jurisdiction: "courts of England and Wales",
} as const;

export const copyrightInceptionYear = 2025;

export const { brandName } = legalCompanyDetails;

export const legalDocumentLinks = [
  { id: "privacy", label: "Privacy", title: "Privacy Policy", slug: "/privacy" },
  { id: "cookies", label: "Cookie Policy", title: "Cookie Policy", slug: "/cookies" },
  { id: "tos", label: "Terms", title: "Terms of Service", slug: "/tos" },
  { id: "disclaimer", label: "Disclaimer", title: "Disclaimer", slug: "/disclaimer" },
] as const;
